// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__Vf7Su","active":"styles_active__T-CBq"};